import { render } from "./IconCatalogFilled.vue?vue&type=template&id=4f79a7aa"
import script from "./IconCatalogFilled.vue?vue&type=script&lang=js"
export * from "./IconCatalogFilled.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__